import { render, staticRenderFns } from "./underlying-edit.vue?vue&type=template&id=3a9dadf5&scoped=true&"
import script from "./underlying-edit.vue?vue&type=script&lang=js&"
export * from "./underlying-edit.vue?vue&type=script&lang=js&"
import style0 from "./underlying-edit.vue?vue&type=style&index=0&id=3a9dadf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9dadf5",
  null
  
)

export default component.exports